import { defineMessages } from 'react-intl';

const _default_1: {
	ofTotalCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	ofTotalCount: {
		id: 'paginated-picker.async-select.pagination-details.of-total-count',
		defaultMessage: '{itemsCount} of {totalCount}',
		description:
			'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.',
	},
});
export default _default_1;
